// extracted by mini-css-extract-plugin
export var container = "Author-module--container--6OWTI";
export var avatar = "Author-module--avatar--23NoN";
export var name = "Author-module--name--1joL0";
export var bio = "Author-module--bio--3cpyN";
export var authorMedium = "Author-module--authorMedium--106oT";
export var contentContainer = "Author-module--contentContainer--18rSs";
export var authorLarge = "Author-module--authorLarge--25qBf";
export var show = "Author-module--show--3vMKE";
export var showFadeInDown = "Author-module--show-fade-in-down--1j5vb";
export var showFadeInUp = "Author-module--show-fade-in-up--3oMlp";
export var hideFadeOut = "Author-module--hide-fade-out--28x7T";